import { useEffect, useState } from "react";
import { endpoints } from "@/lib/api";

// Payment methods the admin has switched ON for a service (API Management). null = still loading.
export function usePaymentMethods(service, open = true) {
  const [methods, setMethods] = useState(null);
  useEffect(() => {
    if (!open) return;
    endpoints.paymentMethods(service).then(({ data }) => setMethods(data.methods || [])).catch(() => setMethods(["momo", "paypal", "stripe"]));
  }, [service, open]);
  return methods;
}
